module.exports = __webpack_public_path__ + "assets/images/isi_play_tablet.png";